/**
 * @param params setters from Format
 */
export function setConfigR49(params) {
    const { setHeaders, setPdfConfig, setExcelConfig, setHtmlConfig, setData, filter } = params;
    const headers = [
        "TOTAL",
        "IMPORTE"
    ]
    setHeaders(headers)
    const tempData = {
        action: "reporteClasificadorPorObjetoDelGasto",
        year: (new Date(filter.year)).getFullYear(),
    }
    setData(tempData);
    const content = [
    ];
    setHtmlConfig({
        headers,
        id: { id: "" },
        content: [content]
    })
    setPdfConfig({
        descr: tempData,
        headers,
        content: [content]
    });
    setExcelConfig({
        headers,
        content: [...content]
    });
}